<template>
  <div v-if="!resetFields" class="draggable-dynamic-table-setting">

    <!--    <div class="navbar-shadow"></div>-->

    <div class="draggable-dynamic-table-setting-wrapper"
            :class="[!box_status ? 'closed' : 'opened', classObj]"
            v-for="(key, key_index) in Object.keys(settings)"
            :key="key_index">

      <div class="table-setting-title-row">
        <div class="useral-font-weight-medium mb-5">
          {{ $t('components.draggableDynamicTable.defaultFilters') }}
        </div>
        <div class="useral-font-weight-medium mb-5">
          {{ $t(settings[key].i18n) || settings[key].title }}
        </div>
      </div>

      <div class="draggableDynamic-table-setting-box" v-if="settings[key].type === 'checkbox'">
        <draggable v-model="headers" handle=".draggable-table-move-icon" :move="checkMove" tag="div" class="draggableDynamic-table-setting-columns" :class="{'dir-rtl': $vs.rtl}">
          <template v-for="(option, option_index) in headers">
            <div class="setting-item"
                 v-if="!option.hasOwnProperty('permission') || $u.checkPermissions(option.permission)"
                 :key="option_index">
              <div class="draggable-table-move-box">
                <div v-if="!option.fixed" class="draggable-table-move-icon">
                  <custom-icon icon="grip-dots-vertical-icon" />
                </div>
              </div>

              <custom-check-box v-if="!option.locked"
                                :value="option"
                                :set-page-change="false"
                                v-model="headers">

              <span class="text-md">
                {{ $t(option.i18n) || option.headerName || option.field }}
              </span>
              </custom-check-box>

              <span class="setting-item-locked" v-else>

                <span class="text-md">
                  {{ $t(option.i18n) || option.headerName || option.field }}
                </span>

                <custom-icon icon="lock-icon" color="danger" />
              </span>
              <div class="u-spacer"></div>
              <filter-box v-if="option.filter && option.hasDefaultFilter"
                          :field="option.field"
                          :filters="option.filterTypes || []"
                          :placeholder="$t('components.draggableDynamicTable.filter.none')"
                          :range="option.filterRange ? option.filterRange : false"
                          :type="option.filterType ? option.filterType : 'search'"
                          :default-value="option.filterDefault ? option.filterDefault : ''"
                          @removeFilters="setFilters($event, option)"
                          @input="setFilters($event, option)"
                          @initValue="initFilterDefaultValue($event, option)"
                          v-model="filterStatus[option.field]"/>
            </div>
          </template>
        </draggable>
      </div>
    </div>

<!--    <div class="draggable-dynamic-table-setting-overlay"
         v-if="box_status"
         @click="$emit('setting:closed'), box_status = false"></div>-->
    <button id="editTableSettingBTN" v-show="false" @click="handleEditTableSetting"></button>
    <button id="resetTableSettingBTN" v-show="false" @click="handleResetSetting"></button>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import CustomCheckBox from '@/components/checkBox/customCheckBox'
import CustomIcon from '../icon/customIcon.vue'
import {mapGetters} from 'vuex'
import FilterBox from './filterBox.vue'

export default {
  name: 'draggingDynamicTableSetting',
  components: {FilterBox, CustomIcon, CustomCheckBox, draggable},
  model: {
    prop: 'activeSettings',
    event: 'input'
  },
  props: {
    status: {
      type: Boolean,
      default: false
    },
    columnsRtl: {
      type: Boolean,
      default: false
    },
    settings: {
      type: Object,
      default: () => { return {} }
    },
    activeSettings: {
      type: Object,
      default: () => { return {} }
    }
  },
  data () {
    return {
      resetFields: false,
      isTypingTimer: 0,
      headers: [],
      box_status: false,
      transitionTimer: 0,
      active_settings: {},
      filterStatus: {}
    }
  },
  created () {
    this.box_status = this.status
    this.initHeaders(true)
  },
  computed: {
    ...mapGetters({
      tablesSetting: 'table/getTableSetting'
    }),
    verticalNavMenuWidth () {
      return this.$store.state.verticalNavMenuWidth
    },
    classObj () {
      if (this.verticalNavMenuWidth === 'default') return 'table-setting-default'
      else if (this.verticalNavMenuWidth === 'reduced') return 'table-setting-reduced'
      else if (this.verticalNavMenuWidth) return 'table-setting-full'
    }
  },
  methods: {
    initHeaders (firstLoad = false) {
      Object.keys(this.settings).forEach((key) => {
        if (this.settings[key].type === 'checkbox') {
          const tableHeader = JSON.parse(JSON.stringify(this.settings[key].options))
          this.activeSettings[this.settings[key].field] = (!this.$vs.rtl) && firstLoad ? tableHeader.reverse() : tableHeader
        }
      })
      const headers = JSON.parse(JSON.stringify(/*(!this.columnsRtl) && firstLoad ? */this.settings.headers.options/* : this.settings.headers.options*/))
      this.headers = this.$vs.rtl ? headers.reverse() : headers
    },
    initFilterDefaultValue (filterValue, option) {
      this.filterStatus[option.field] = filterValue
    },
    setFilters (filter, column) {
      clearTimeout(this.isTypingTimer)
      // this.isTypingTimer = setTimeout(() => {
      const columnIndex = this.headers.map(elm => elm.field).indexOf(column.field)
      this.headers[columnIndex].filterDefault = filter.search
      if (this.headers[columnIndex].filterType === 'checkbox') {
        this.headers[columnIndex].filterTypes = filter.search
      }
      // }, 500)
    },
    checkMove (column) {
      const { index, futureIndex } = column.draggedContext
      return !(this.settings.headers.options[index].fixed || this.settings.headers.options[futureIndex].fixed)
    },
    handleEditTableSetting () {
      this.$emit('filter:set', this.filterStatus)
      this.activeSettings.headers = this.$vs.rtl ? this.headers.reverse() : this.headers
      this.$emit('input', this.activeSettings)
      this.$nextTick(() => {
        this.$emit('setting:closed')
      })
    },
    handleResetSetting () {
      this.resetFields = true
      this.$nextTick(() => {
        this.initHeaders(false)
        this.resetFields = false
      })
    }
  },
  watch: {
    status: {
      handler (val) {
        this.box_status = val
        document.querySelectorAll('.draggable-dynamic-table-setting-wrapper').forEach(el => {
          el.style.overflowY = 'hidden'
        })
        clearTimeout(this.transitionTimer)
        this.transitionTimer = setTimeout(() => {
          document.querySelectorAll('.draggable-dynamic-table-setting-wrapper').forEach(el => {
            el.style.overflowY = 'auto'
          })
        }, 200)
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
.draggable-dynamic-table-setting {
  padding: 5px;

  .navbar-shadow {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    height: 10px;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.3), transparent);
    z-index: 50000;
  }

  .draggable-dynamic-table-setting-wrapper {
    direction: rtl;
    position: relative;
    width: 100%;
    padding: 10px;
    z-index: 10000;
    overflow: hidden;
    transition: all 0.2s ease;
    border-bottom: 0 solid #333333;
    border-radius: 0.5rem;
    background-color: #cecece30;

    &::-webkit-scrollbar {
      display: block;
      border-radius: 4px;
      width: 4px !important;
      background: #222222;
      float: left;
    }

    &::-webkit-scrollbar-thumb {
      display: block;
      border-radius: 5px;
      background: #555555;
    }

    * {
      text-align: left;
    }

    /*&.table-setting-default {
      width: calc(100% - 260px) !important;
    }

    &.table-setting-reduced {
      width: calc(100% - 80px) !important;
    }

    &.table-setting-full {
      width: calc(100%) !important;
    }*/
    .table-setting-title-row {
      display: flex;
      justify-content: space-between;
      padding: 0 5px;
    }

    .draggableDynamic-table-setting-box {
    }

    .draggableDynamic-table-setting-columns {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    .setting-item {
      display: flex;
      align-items: center;
      flex-direction: row-reverse;
      line-height: 30px;
      min-height: 52px;
      border: 1px solid #cecece;
      border-radius: 0.5rem;
      background-color: #fff;
      padding: 5px;

      .draggable-table-move-box {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 25px;
        width: 25px;

        .draggable-table-move-icon {
          cursor: move;
        }
      }

      .filter-box {
        max-width: 50%;

        .filter-icon-box {
          position: unset;

          .filter-icon {
            left: 5px;
          }
        }

        .u-select {
          margin: 0;

          .u-select-label-box {
            flex-direction: row-reverse;
          }
        }

        .filter-suggest-box {
          position: absolute;
          top: 100%;
        }
      }

      i {
        font-size: 15px;
        vertical-align: middle;
      }

      .setting-item-locked {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 0 5px;
        gap: 5px;
      }
    }

    .custom-check-box {
      direction: ltr;

      .check-box {
        //margin-top: 5px;
      }

      .check-box-label {
        line-height: 30px;
      }
    }
  }

  .custom-check-box {
    padding: 0 5px;
  }

  @media (max-width: 576px) {
    .icon-lock {
      margin-left: 20px !important;
      font-size: 21px !important;
      margin-right: 2px !important;
    }
  }

  .draggable-dynamic-table-setting-overlay {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 9999;
  }
}
</style>
